import React from 'react';
import { Accordion } from './ui/Accordion';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/metaPixel';
import { getCartUrl } from '../utils/cartUrls';
interface FAQSectionProps {
  bump1?: boolean;
  bump2?: boolean;
}
export function FAQSection({
  bump1 = false,
  bump2 = false
}: FAQSectionProps) {
  const basePrice = 7.49;
  const bumpPrice = 9.97;
  const finalPrice = basePrice + (bump1 ? bumpPrice : 0) + (bump2 ? bumpPrice : 0);
  const faqs = [{
    question: '¿Esto es una dieta estricta o voy a tener que prohibirme todo?',
    answer: 'Absolutamente no. El Protocolo Reset no se basa en la restricción sino en la Biología Aplicada. Aprenderás el orden exacto de los alimentos y cómo combinarlos para desactivar la enzima COX-2. Podés seguir disfrutando de tus comidas favoritas, incluso postres de chocolate, simplemente sabiendo cuándo y cómo integrarlos.'
  }, {
    question: '¿Voy a pasar hambre o quedarme con antojos?',
    answer: 'No. Al equilibrar tu glucosa con los Aceleradores de Postres y Snacks, tu cuerpo deja de enviar señales falsas de hambre. Vas a comer para nutrirte y sentirte satisfecha, no para aguantar hasta la próxima comida.'
  }, {
    question: '¿Funciona aunque coma sano y aun así me inflame?',
    answer: 'Esta es la situación del 80% de nuestras usuarias. El problema no es la calidad de tu comida, sino que tu CMM está apagado. El Protocolo Reset está diseñado específicamente para re-encender ese mecanismo. Cuando tu biología se ordena, hasta los alimentos que hoy te inflaman dejan de ser un problema.'
  }, {
    question: 'No tengo mucho tiempo para cocinar, ¿es para mí?',
    answer: 'Es especialmente para vos. El Acelerador 3 te enseña a preparar tus desayunos de la semana en 30 minutos el domingo. Las recetas están diseñadas para hacerse en 15 a 20 minutos con ingredientes de tu supermercado local.'
  }, {
    question: '¿Sirve si tengo más de 40 o 50 años?',
    answer: 'Fue creado específicamente para vos. Después de los 40, la caída de estrógenos y el aumento de cortisol cambian las reglas del metabolismo. Este protocolo usa técnicas de Biohacking Hormonal para trabajar con tu nueva biología, no en su contra.'
  }, {
    question: '¿Y si lo compro y no es para mí?',
    answer: 'Tenés 7 días para probarlo con cero riesgo. Si aplicás el método y no sentís que tu ropa te queda más floja y tu digestión está más tranquila, te devolvemos el 100% de tu dinero. Sin formularios. Sin preguntas. El riesgo es completamente nuestro.'
  }];
  return <section className="py-10 bg-transparent" data-id="element-188">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <div className="text-center mb-8" data-id="element-190">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-black mb-4" data-id="element-191">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-sage/80" data-id="element-192">
            Todo lo que necesitás saber antes de tu transformación.
          </p>
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-193">
          <Accordion items={faqs} data-id="element-194" />

          <div className="text-center mt-10" data-id="element-195">
            <a href={getCartUrl(bump1, bump2)} onClick={e => trackAddToCart(e)} target="_blank" rel="noopener noreferrer" className="inline-block w-full sm:w-auto" data-id="element-196">
              <Button size="xl" variant="primary" className="w-full sm:w-auto px-10 shadow-gold/30" data-id="element-197">
                YA ME QUEDÓ CLARO, QUIERO MI RESET POR ${finalPrice.toFixed(2)}
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>;
}